function CiConfigurationViewController(toasterService, ConditionService, eventService) {
    const ctrl = this;

    ctrl.$onInit = () => {
        ctrl.originalConfig = angular.copy(ctrl.config);
        ctrl.confirmationActive = false;
    };


    ctrl.checkChanges = () => {
        return !angular.equals(ctrl.originalConfig, ctrl.config);
    }

    ctrl.activateSave = () => {
        ctrl.confirmationActive = true;
    };

    ctrl.cancelSave = () => {
        ctrl.confirmationActive = false;
    };

    ctrl.returnToList = () => {
        eventService.broadcast('return-ci-list');
    }

    ctrl.saveCi = async (ci) => {
        await ConditionService.saveCiConfig({
            ciType: ci.ciNumber,
        }, ci).then(
            function () {
                toasterService.success('toaster.ci-save-success');
                eventService.broadcast('update-train-health');
                eventService.broadcast('update-ci-list', ctrl.config);
                eventService.broadcast('update-device-list');
                ctrl.originalConfig = angular.copy(ctrl.config);
            },
            function (error) {
                toasterService.error('toaster.ci-save-error');
                console.log(error);
            });

        ctrl.confirmationActive = false;
    }
}

angular
    .module('modalDirectives')
    .controller('CiConfigurationViewController', CiConfigurationViewController);
